// extracted by mini-css-extract-plugin
export default {"ring":"Loading_ring__FBdEO","animateC":"Loading_animateC__nYTjw","circle":"Loading_circle__7nhys","animate":"Loading_animate__nZ7hx"};